export const creditRatingAlerts = {
  conflictOfInterests: (companyName) =>
    `Scope Ratings GmbH is prohibited from issuing a public or subscription credit rating on ${companyName} or any of its subsidiaries in accordance with EU laws and specifically the Rating Agency Regulation on Credit Rating Agencies (EC) No 1060/2009 as amended by Regulation (EU) No 513/2011 and Regulation (EU) No 462/2013.`,
  confidentialAlert: {
    title:
      'Subscription, Restricted Subscription, and Private Ratings are for Subscribers only and must be kept confidential.',
    message:
      'The credit rating(s) and outlook(s) provided on this screen may not be shared with any unauthorised third party.',
  },
};
